// extracted by mini-css-extract-plugin
export var blankPhoto = "PostMeta-module--blankPhoto--fa04a";
export var postDetails = "PostMeta-module--postDetails--ffeb8";
export var postMeta = "PostMeta-module--postMeta--d867f";
export var postPhoto = "PostMeta-module--postPhoto--aed92";